import { IPromotionService, IPromotionState } from '../types';
import { IPublishTermsSuccessPayload } from '../../../../actions/publishTerms';
import { selectActiveServiceId } from '../selectors';

export const mergeServices = (state: IPromotionState, payload: IPublishTermsSuccessPayload): IPromotionService[] => {
  const selectedService = selectActiveServiceId({ servicePickerWidgetV2: { promotion: state } } as any);

  if (selectedService) {
    payload.dataV2.promotion.services.forEach(service => {
      if (service.type === selectedService && !service.disabled) {
        service.selected = true;
      }
    });
  }

  return payload.dataV2.promotion.services;
};
